import React from 'react';
import '../App.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

// Add these imports for AOS animations
import AOS from 'aos';
import 'aos/dist/aos.css';

// Partner logos
import faber from '../images/partners/ap.png';
import freedomTree from '../images/partners/faber.png';
import dDecor from '../images/partners/1.png';
import partner4 from '../images/partners/elica.png';
import partner5 from '../images/partners/3.png';

// Initialize AOS
AOS.init();

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4,
        slidesToSlide: 1
    },
    tablet: {
        breakpoint: { max: 1024, min: 768 },
        items: 3,
        slidesToSlide: 1
    },
    mobile: {
        breakpoint: { max: 768, min: 0 },
        items: 2,
        slidesToSlide: 1
    }
};

export default class Partners extends React.Component {
    render() {
        const partners = [
            { img: faber, name: 'Faber' },
            { img: freedomTree, name: 'Freedom Tree' },
            { img: dDecor, name: 'D Decor' },
            { img: partner4, name: 'Partner 4' },
            { img: partner5, name: 'Partner 5' }
        ];

        return (
            <div>
                <div className="container aboutUs-custom-top container-sm" style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <div id="#scrolly-div" className="row add-mobile-padding">
                        <div className="col-sm-6 col-md-6 mt-sm-5">
                            <div className="row mt-sm-5">
                                <div data-aos="fade-right" data-aos-duration="1000" className="col-2 col-sm-1">
                                    <span><hr className="slash"></hr></span>
                                </div>
                                <div className="col-10 col-sm-11">
                                    <p data-aos="fade-left" data-aos-duration="1000" className="about-topic">PARTNERS</p>
                                </div>
                            </div>
                            <div className="row">
                                <p className="about-sub-topic">
                                    <span style={{ color: '#2c3e50' }}>OUR</span>
                                    <span style={{ color: '#cd853f' }}> PARTNERS</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Partners Carousel */}
                <div style={{ marginBottom: '20px', clear: 'both', padding: '0 20px' }}>
                    <Carousel
                        responsive={responsive}
                        autoPlay={true}
                        infinite={true}
                        arrows={true}
                        showDots={false}
                        swipeable={true}
                        draggable={true}
                    >
                        {partners.map((partner, index) => (
                            <div key={index} className="text-center partner-item" style={{ padding: '20px' }}>
                                <img 
                                    src={partner.img} 
                                    alt={partner.name}
                                    style={{ 
                                        maxWidth: '150px', 
                                        maxHeight: '100px', 
                                        objectFit: 'contain',
                                        margin: '0 auto'
                                    }}
                                />
                            </div>
                        ))}
                    </Carousel>
                </div>
            </div>
        )
    }
}
